export default __webpack_public_path__ + "static/media/import-csv-example-translations.0d2cd612.csv";